import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Link } from "react-router-dom";
// ✅ Imports de imágenes locales
import bodasImage from "@/assets/images/eventos/bodas.jpg";
import eventosFamiliaresImage from "@/assets/images/eventos/eventos-familiares.jpg";
import retirosCorporativosImage from "@/assets/images/eventos/retiros-corporativos.jpg";

const EVENT_TYPES = [
  {
    title: "Bodas",
    desc: "Celebra el día más importante en un entorno de ensueño, con espacios íntimos y vistas inigualables.",
    image: bodasImage
  },
  {
    title: "Eventos Familiares",
    desc: "Reuniones, aniversarios y celebraciones privadas diseñadas a tu medida.",
    image: eventosFamiliaresImage
  },
  {
    title: "Retiros & Corporativos",
    desc: "Espacios ideales para retiros de bienestar, equipos de trabajo y reuniones privadas.",
    image: retirosCorporativosImage
  }
];

export default function Eventos() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="eventos" ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-secondary/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            Eventos
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-light text-foreground text-balance"
          >
            Celebraciones inolvidables
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="text-foreground/60 font-light text-lg mt-6 max-w-2xl mx-auto"
          >
            Bodas, retiros, reuniones empresariales y celebraciones privadas en
            un entorno diseñado para crear recuerdos.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {EVENT_TYPES.map((evt, i) => (
            <motion.div
              key={evt.title}
              initial={{ opacity: 0, y: 40 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1, delay: 0.2 + i * 0.1 }}
              className="group relative aspect-[3/4] overflow-hidden bg-neutral-800"
            >
              {/* ✅ Imagen nativa con object-cover - sin estiramiento */}
              <img
                src={evt.image}
                alt={evt.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="font-serif-display text-2xl text-white font-light mb-3">
                  {evt.title}
                </h3>
                <p className="text-white/70 text-sm font-light leading-relaxed mb-4">
                  {evt.desc}
                </p>
                <Link
                  to="/reservar"
                  className="inline-flex items-center gap-2 text-white/80 text-xs tracking-wide uppercase font-light hover:text-white transition-colors"
                >
                  Consultar disponibilidad →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}